import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import dateFormat from 'utils/helper/dateFormat';
import styled from 'styled-components';
import dateMiniuteHourFormat from 'utils/helper/dateMiniuteHourFormat';

interface IProps {
  data: any;
  handleDatepickderChange: (dateString: any) => void;
}
const { RangePicker } = DatePicker;

const RangeDatepickerStyled: React.FC<IProps> = ({
  data,
  handleDatepickderChange,
}) => {
  return (
    <RangeDatePickerWrapper
      size='large'
      value={[
        data?.extension?.sale_start_date
          ? dayjs(
              moment(data?.extension?.sale_start_date).format(
                dateMiniuteHourFormat,
              ),
              dateMiniuteHourFormat,
            )
          : null,
        data?.extension?.sale_end_date
          ? dayjs(
              moment(data?.extension?.sale_end_date).format(
                dateMiniuteHourFormat,
              ),
              dateMiniuteHourFormat,
            )
          : null,
      ]}
      showTime
      format={dateMiniuteHourFormat}
      onChange={(date, dateString) => {
        handleDatepickderChange(dateString);
      }}
    />
  );
};

export default RangeDatepickerStyled;

const RangeDatePickerWrapper = styled(RangePicker)`
  width: 100%;
`;
